export default "__VITE_ASSET__DR21TXNi__"